import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { StationgroupService } from '../service/stationgroup.service';
import { DialogService, ResponseStatus, WidgetReference, WidgetStyle } from '@sdbn/common';
import { ContextChange, DashboardContext } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';

import { MatDialog } from '@angular/material/dialog';
import { StationGroup, StationSet } from '../model/yard-structure.model';
import { MasterDetailListEntry } from '@sdbn/common';

@Component({
    selector: 'app-yard-structure',
    templateUrl: './yard-structure.component.html',
    styleUrls: ['./yard-structure.component.scss'],
    standalone: false
})
export class YardStructureComponent extends AbstractWidgetComponent implements OnInit {

  stationGroups = new Array<StationGroup>();
  visibleStationGroups = new Array<StationGroup>();
  stationGroupsBackup: StationGroup[] = [];

  stationGroup: StationGroup;
  stationSet: StationSet;

  selection: Array<MasterDetailListEntry>;

  responseMessages = null;
  requestRunning = false;

  reference: WidgetReference;
  context: DashboardContext;

  @ViewChild('form', { static: true }) form: NgForm;

  constructor(
    private dialog: MatDialog,
    private stationgroupService: StationgroupService,
    private dialogService: DialogService
  ) {
    super();
  }

  updateVisibleStationGroups() {
    this.visibleStationGroups = this.stationGroups.filter(sg => !sg.deleted);
    console.log('visible data is', this.visibleStationGroups);
  }

  ngOnInit() {
    this.loadStationGroups();
  }

  selectStationGroup(stationGroup: StationGroup) {
    this.selection = [stationGroup];
  }

  isStationGroupSelected(stationGroup: StationGroup): boolean {
    if (this.selection != null && this.selection.length > 0) {
      return this.selection[0] === stationGroup;
    }
    return false;
  }

  selectStationSet(stationGroup: StationGroup, stationSet: StationSet) {
    this.selection = [stationGroup, stationSet];
  }

  isStationSetSelected(stationGroup: StationGroup, stationSet: StationSet): boolean {
    if (this.selection != null && this.selection.length > 1) {
      return this.selection[0] === stationGroup && this.selection[1] === stationSet;
    }
    return false;
  }

  addStationGroup() {
    // calculate newStationGroupCount
    let newStationGroupCount = 0;
    if (this.stationGroups.length > 0) {
      // get minimum id of stationGroups
      const minId = this.stationGroups.reduce((prev, curr) => {
        return prev.id < curr.id ? prev : curr;
      }).id;
      if (minId != null && minId < 0) {
        // set newStationCount to absolute value of minimum id
        newStationGroupCount = Math.abs(minId);
      }
    }
    newStationGroupCount++;

    // add new stationGroup
    const stationGroup = new StationGroup();
    stationGroup.id = -(newStationGroupCount);
    stationGroup.stationSets = [];
    stationGroup.name = 'neue Stationsgruppe ' + stationGroup.id;

    this.stationGroups.push(stationGroup);
    this.updateVisibleStationGroups();
    this.selectStationGroup(stationGroup);

    this.form.form.markAsDirty();
  }

  saveChanges() {
    this.responseMessages = [];
    this.stationgroupService.saveStationGroups(this.stationGroups).subscribe(response => {
      if (response.status === ResponseStatus.SUCCESS) {
        this.reload();
      } else {
        this.responseMessages = response.responseMessages;
      }
    }, error => {
      console.log(error);
    });
  }

  cancel() {
    this.responseMessages = [];
    this.reload();
  }

  reload() {
    this.loadStationGroups();
    this.form.resetForm();
  }

  addStationSetToStationGroup(stationGroup: StationGroup) {
    // calculate newStationSetCount
    let newStationSetCount = 0;
    if (stationGroup.stationSets.length > 0) {
      // get minimum id of stationSets
      const minId = this.stationGroup.stationSets.reduce(function (prev, curr) {
        return prev < curr ? prev : curr;
      }).id;
      if (minId != null && minId < 0) {
        // set newStationCount to absolute value of minimum id
        newStationSetCount = Math.abs(minId);
      }
    }
    newStationSetCount++;

    // add new stationSet to stationGroup
    const stationSet = new StationSet();
    stationSet.id = -(newStationSetCount);
    stationSet.stations = [];
    stationSet.name = 'neues Stations Set ' + stationSet.id;
    this.stationGroup.stationSets.push(stationSet);

    this.selectStationSet(stationGroup, stationSet);
    this.updateVisibleStationGroups();

    this.form.form.markAsDirty();
  }

  loadStationGroups() {
    this.stationgroupService.getStationGroups().subscribe(
      response => {


        let newStationGroups = new Array<StationGroup>();
        for (let stationGroup of response) {
          newStationGroups.push(new StationGroup(stationGroup));
        }
        this.stationGroups = newStationGroups;
        this.updateVisibleStationGroups();

        // selection anhand ids wieder aufbauen
        if (this.selection != null && this.selection.length > 0) {
          let newSelection = new Array<MasterDetailListEntry>();
          let selectedStationGroup = this.selection[0] as StationGroup;
          for (let stationGroup of this.stationGroups) {
            if (stationGroup.id === selectedStationGroup.id) {
              newSelection.push(stationGroup);
              break;
            }
          }
          if (newSelection.length > 0 && this.selection.length > 1) {
            let selectedStationSet = this.selection[1] as StationSet;
            for (let stationSet of (newSelection[0] as StationGroup).stationSets) {
              if (stationSet.id === selectedStationSet.id) {
                newSelection.push(stationSet);
                break;
              }
            }
          }

          this.selection = newSelection;

        }

        if (this.selection == null && this.stationGroups.length > 0) {
          this.selection = new Array<MasterDetailListEntry>();
          this.selection.push(this.stationGroups[0]);
        }

      },
      error => {
        console.log('Error while getting stationgroups!', error);
      });
  }

  public isSaveDisabled() {
    return this.form.invalid;
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  onSelectionChanged(entry: MasterDetailListEntry) {

    if (entry instanceof StationGroup) {
      this.stationGroup = entry as StationGroup;
      this.stationSet = null;
    } else if (entry instanceof StationSet) {
      this.stationSet = entry as StationSet;
    }
  }

  onAddEntry(parentPath: Array<MasterDetailListEntry>) {

    console.log('adding entry on path', parentPath);

    if (parentPath == null || parentPath.length == 0) {
      this.addStationGroup();
    }

    if (parentPath != null && parentPath.length > 0) {
      this.addStationSetToStationGroup(parentPath[0] as StationGroup);
    }

  }

  onDeleteEntry(entry: MasterDetailListEntry) {
    console.log('deleting entry', entry);

    if (entry instanceof StationGroup) {
      this.deleteStationGroup(entry as StationGroup);
    } else if (entry instanceof StationSet) {
      this.deleteStationSet(entry as StationSet)
    }

  }

  deleteStationGroup(stationGroup: StationGroup) {

    this.dialogService.showConfirm(
      'tmc.admin.yard-structure.confirm-dialog.title',
      'tmc.admin.yard-structure.delete-group.confirm-dialog.message'
    ).afterClosed().subscribe(confirm => {
      if (confirm) {
        if (stationGroup.id > -1) {
          stationGroup.deleted = true;
          for (let stationSet of stationGroup.stationSets) {
            stationSet.deleted = true;
          }
          this.form.form.markAsDirty();
        } else {
          const index = this.stationGroups.indexOf(stationGroup);
          this.stationGroups.splice(index, 1);
        }
        this.stationGroup = null;
        this.stationSet = null;
        this.updateVisibleStationGroups();
        this.form.form.markAsDirty();
      }
    });

  }

  deleteStationSet(stationSet: StationSet) {

    this.dialogService.showConfirm(
      'tmc.admin.yard-structure.confirm-dialog.title',
      'tmc.admin.yard-structure.delete-set.confirm-dialog.message'
    ).afterClosed().subscribe(confirm => {
      if (confirm) {
        stationSet.deleted = true;
        if (stationSet.id < 0) {
          const index = this.stationGroup.stationSets.findIndex(set => set.id === stationSet.id);
          this.stationGroup.stationSets.splice(index, 1);
        }
        this.stationSet = null;
        this.form.form.markAsDirty();
        this.updateVisibleStationGroups();
      }
    });

  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
